<!-- Legacy alert design — shown to regular users until the new toast design is approved. -->
<div class="alert-container" *ngIf="!useNewToastDesign">
  <div class="alert-block" *ngFor="let alert of alerts">
    <div class="{{ cssClass(alert) }}">
      <div class="alert-icon">
        <span class="icon-ic_big_a"></span>
      </div>
      <div class="alert-content">
        <div class="alert-title">{{ alert.title }}</div>
        <div class="alert-message" *ngIf="alert.message">{{ alert.message }}</div>
        <div class="contact-to-support" *ngIf="alert.type === enumAlertType.Error && !isAdminOrSupport">
          <button class="btn btn-link" (click)="contactToSupport()">{{ "BUTTON.CONTACT_SUPPORT" | translate }}</button>
        </div>
      </div>
      <div class="alert-close-button"><a class="close" (click)="removeAlert(alert)">&times;</a></div>
    </div>
  </div>
</div>

<!-- New toast design — management side only (support/admin/super + customs broker). -->
<div class="toast-stack" aria-live="polite" aria-atomic="true" *ngIf="useNewToastDesign">
  <div
    *ngFor="let alert of alerts"
    class="toast {{ typeClass(alert) }}"
    [class.enter]="!leavingAlerts.has(alert)"
    [class.leave]="leavingAlerts.has(alert)"
    [class.run]="alert.isCloseAfterTimeout && !leavingAlerts.has(alert)"
    [style.--life.ms]="alertLifeMs"
    [attr.role]="alert.type === enumAlertType.Error ? 'alert' : 'status'"
    (mouseenter)="onHover(alert)"
    (mouseleave)="onLeave(alert)"
  >
    <span class="toast-icon">
      <ng-container [ngSwitch]="alert.type">
        <svg *ngSwitchCase="enumAlertType.Success" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M5 12.5l4.4 4.4L19 7.2" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <svg *ngSwitchCase="enumAlertType.Error" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <svg *ngSwitchCase="enumAlertType.Warning" width="19" height="19" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 4.2l8.4 14.6a1 1 0 0 1-.87 1.5H4.47a1 1 0 0 1-.87-1.5L12 4.2z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path d="M12 10v4" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
          <circle cx="12" cy="17" r="1.15" fill="currentColor" />
        </svg>
        <svg *ngSwitchDefault width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="7.5" r="1.3" fill="currentColor" />
          <path d="M12 11v7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
        </svg>
      </ng-container>
    </span>

    <div class="toast-body">
      <p class="toast-title" *ngIf="alert.title">{{ alert.title }}</p>
      <p class="toast-msg" *ngIf="alert.message" [innerHTML]="alert.message"></p>
      <div class="toast-action" *ngIf="alert.type === enumAlertType.Error && !isAdminOrSupport">
        <button type="button" class="btn btn-link" (click)="contactToSupport()">{{ "BUTTON.CONTACT_SUPPORT" | translate }}</button>
      </div>
    </div>

    <button type="button" class="toast-close" (click)="dismiss(alert)" [attr.aria-label]="'BUTTON.CLOSE' | translate">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
      </svg>
    </button>

    <span class="toast-progress" *ngIf="alert.isCloseAfterTimeout"></span>
  </div>
</div>

<custom-modal
  [open]="modalErrorShown"
  [header]="(isAdminOrSupport ? 'LABELS.GENERIC_API_ADMIN_ERROR' : 'LABELS.GENERIC_API_USER_ERROR') | translate"
  [isAlert]="true"
  *ngFor="let alert of modalAlerts"
>
  <div [innerHTML]="alert.message | translate"></div>
</custom-modal>

<custom-modal [isOpenOrCloseOnInit]="true" [open]="modalInfoShown" [header]="alert.title" *ngFor="let alert of modalAlerts">
  <div [innerHTML]="alert.message | translate"></div>
</custom-modal>

<custom-modal [open]="modalSuccessShown" [header]="alert.title" [isAlert]="true" *ngFor="let alert of modalAlerts">
  <div [innerHTML]="alert.message | translate"></div>
</custom-modal>
